<!-- 移动端的页头部分 -->
<template>
  <div class="header-component">
    <div class="box" :style="drawer ? '' : 'border-bottom-width:1px'">
      <!-- 左边logo -->
      <router-link to="/home">
        <img class="img-logo" src="../../assets/images/logo-text.webp" alt />
      </router-link>
      <!-- 下拉菜单 -->
      <img
        @click="transitiona"
        class="img-routerto"
        src="../../assets/images/header_icon.png"
        alt
      />
    </div>
    <el-drawer
      :visible.sync="drawer"
      :direction="'rtl'"
      custom-class="nav-drawer"
      title="菜单"
      size="320px"
    >
      <div class="header-nav">
        <el-menu unique-opened>
          <el-menu-item index="1"> <a href="/home">首页</a></el-menu-item>
          <el-submenu v-for="(item, i) in menuArr" :key="i" :index="'2-' + i">
            <template slot="title">
              <div @click="onMenu(item)">
                {{ item.title }}
              </div>
            </template>
            <template v-if="item.title != '公众服务'">
              <el-menu-item
                v-for="(childItem, childI) in item.children"
                :key="childI"
                :index="'childI2-' + childI"
                @click="onMenuItem(item, childItem)"
              >
                {{ childItem.tag }}
              </el-menu-item>
            </template>
            <template v-else>
              <el-submenu index="2-a-4">
                <template slot="title"><div>在线服务</div></template>
                <el-menu-item
                  v-for="(childItem, childI) in item.grouping1"
                  :key="childI"
                  :index="'childI4-' + childI"
                >
                  <a :href="childItem.url" target="_blank">{{
                    childItem.tag
                  }}</a>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="2-a-5">
                <template slot="title">
                  <div
                    @click="
                      onMenuItem(
                        {
                          path: '/document',
                          children: item.grouping2,
                          title: '公众服务'
                        },
                        {
                          tag: item.grouping2[0].tag,
                          to: 0,
                          key: item.grouping2[0].key
                        }
                      )
                    "
                  >
                    办事指南
                  </div>
                </template>
                <el-menu-item
                  v-for="(childItem, childI) in item.grouping2.filter(item => item.tag !== '承检能力')"
                  :key="childI"
                  :index="'childI5-' + childI"
                  @click="
                    onMenuItem(
                      {
                        path: '/document',
                        children: item.grouping2,
                        title: '公众服务'
                      },
                      childItem
                    )
                  "
                >
                  {{ childItem.tag }}
                </el-menu-item>
              </el-submenu>
              <el-submenu index="2-a-6">
                <template slot="title"
                  ><div
                    @click="
                      onMenuItem(
                        {
                          path: '/office-hall',
                          children: item.children,
                          title: '公众服务'
                        },
                        {
                          tag: item.children[0].tag,
                          to: 0,
                          key: item.children[0].key
                        }
                      )
                    "
                  >
                    公正性声明
                  </div>
                </template>
                <el-menu-item
                  v-for="(childItem, childI) in item.children"
                  :key="childI"
                  :index="'childI6-' + childI"
                  @click="onMenuItem(item, childItem)"
                >
                  {{ childItem.tag }}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
        </el-menu>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      drawer: false
    }
  },
  components: {},
  methods: {
    // 点击右上角，显示灰黑的背景和菜单栏
    transitiona() {
      this.drawer = !this.drawer
    },
    onMenu(item) {
      this.$router.push({
        path: item.path,
        query: {
          title: item.title,
          tag: item.children[0].tag,
          key: item.children[0].key
        }
      })
      this.$store.commit('SET_TABS', item)
      this.transitiona()
    },
    // 跳转本地
    onMenuItem(item, { tag, to, key, hash }) {
      this.$router.push({
        path: item.path,
        query: { title: item.title, tag, key },
        hash
      })

      this.$store.commit('SET_TABS', item)
      this.transitiona()
    }
  },
  computed: {
    ...mapState(['menuArr'])
  },
  created() {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@function pxTorem($px) {
  $html-font-size: 100px;
  @return ($px/$html-font-size) + rem;
}

.header-component {
  width: 100%;
  height: 58px;
  background: #fff;
  z-index: 83;
  position: fixed;
  .box {
    width: 100%;
    height: 58px;
    position: relative;
    background: #fff;
    display: flex;
    border-bottom: pxTorem(0px) solid rgba(166, 166, 166, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 pxTorem(16px);
  }
  .img-logo {
    width: 3rem;
    height: pxTorem(48px);
    object-fit: contain;
  }
  .img-routerto {
    width: pxTorem(32px);
    height: pxTorem(32px);
    object-fit: contain;
    border-radius: 4px;
  }
  .nav-drawer {
    .el-drawer__title {
      height: 58px;
    }
  }
  .is-active {
    color: #3468cb;
  }

  ::v-deep .el-drawer__header {
    margin-bottom: 0;
    padding: 0 16px;
    height: 58px;
    background: url(../../assets/images/tab_bg_1.webp);
    span {
      color: #14579e;
      font-weight: 800;
    }
    .el-drawer__close-btn {
      color: #14579e;
      font-weight: 800;
    }
  }
  ::v-deep .el-drawer {
    border-radius: 16px 16px 0 0;
    overflow: hidden;
  }
  ::v-deep .el-menu-item {
    a {
      color: #000;
      font-size: 16px;
      display: block;
      width: calc(100% - 20px);
    }
  }
  ::v-deep .el-submenu__title {
    > div {
      width: calc(100% - 20px);
    }
    i {
      font-size: 18px;
    }
  }
  ::v-deep .el-menu--inline {
    background-color: #1b6ad210;
  }
  .el-menu {
    border: none;
  }
  ::v-deep .el-drawer__body {
    padding-top: pxTorem(8px);
  }
}
</style>
